import React from 'react'
import styles from './FormFieldError.module.scss'

interface FormFieldErrorProps {
  message?: React.ReactNode
}

const FormFieldError = ({ message }: FormFieldErrorProps) => {
  return message ? <div className={styles.FormFieldError}>{message}</div> : null
}

export default FormFieldError
